import { hFetch } from './hFetch';

export const getContactOnboardingTasks = async ({ id }: { id: number }) => {
  return await hFetch({ url: `/api/contacts/${id}/onboarding_tasks` });
};
